module.exports = __webpack_public_path__ + "img/logo.35e4ab72.svg";